import { IAppConfig, IPanel, ISourceInfo } from "smarthub-common";
import { middlewares } from "middleware";
import { providers } from "./providers";
import { chatScopes } from "./chat-scopes.config";
import { actions } from "./actions.config";
import { viewConfig } from "./view.config";
import { IProps } from "./props";
import { themes } from "./themes";
import { localize } from "./localize";
import { getPanel } from "./panels";

const source = navigator.userAgent.indexOf("SmartHub") >= 0 ? "app" : "web";

const areas = [];
const smarthubEnv = "{env.smarthubEnv}";
const botEnv = "{env.botEnv}";
const contentEnv = "{env.contentEnv}";

const props: IProps = {
  env: contentEnv.length ? contentEnv : "prod",
  position: "{env.position}",
  id: "{env.id}",
  source,
  serviceUris: {
    userToken: "{env.userTokenUri}",
    botToken: "{env.botTokenUri}",
    panel: "{env.panelUri}",
    transform: "{env.transformUri}",
  },
  tpcc: {
    checkUri: "{env.tpcCheckUri}",
    infoUri: "{env.tpcInfoUri}",
  },
  botHandle: "{env.botHandle}",
  personality: "{env.personality}",
};

if (smarthubEnv.length)
  areas.push({
    name: "SmartChat",
    label: smarthubEnv,
  });

if (botEnv.length)
  areas.push({
    name: "Flex",
    label: botEnv,
  });

if (contentEnv.length)
  areas.push({
    name: "SharePoint",
    label: contentEnv,
  });

const sourceInfo: ISourceInfo = {
  name: "{package.name}",
  title: "{package.productName}",
  shortTitle: "{package.displayName}",
  publisher: "{package.publisher}",
  description: "{package.description}",
  environment: {
    label: "{env.label}",
    areas,
  },
  version: "{package.version}",
  sourceType: source,
  poweredByUri: "https://www.ics.ai/",
};

let hideUploadButton = "{env.hideUploadButton}";

const { checkUri, infoUri } = props.tpcc;

export const panels: IPanel[] = getPanel(props);

console.log("props", props);

export const config = (): IAppConfig => ({
  sourceInfo,
  actions,
  tpcCheck: {
    checkUri,
    level: "none",
    infoUri,
  },
  adaptiveCardHostConfig: {},
  webChatConfig: {
    sendTyping: true,
    sendTypingIndicator: true,
    styleOptions: {
      hideUploadButton: hideUploadButton == "true",
    },
  },
  chatScopes,
  knownUris: {},
  middleware: middlewares(),
  localizeConfig: localize(props),
  providers: providers(props),
  themes: themes(props),
  view: viewConfig(props),
});
